import { useEffect } from 'react';

import { GenericErrorMessage, Layout } from '@tgg/ui';
import { createTraceParameters } from '@tgg/util';

import { appLogger } from 'apps/commerce/core/appLogger';

import image from '../../public/ywnqh/images/skipping-rope.png';

export function FiveHundred() {
    useEffect(() => {
        const loggerParameters = createTraceParameters({
            context: null,
            parameters: {
                operation: '/500/ page',
            },
        });
        appLogger.info(`Opening /500/ page`, loggerParameters);
    }, []);
    return (
        <Layout>
            <GenericErrorMessage
                mainHeading="Uh-Oh!"
                heading="Something must be tangled"
                contactLink="/contact-us/"
                primaryButtonText="go to homepage"
                primaryLink="/"
                secondaryButtonText="find a gym"
                secondaryLink="/find-a-gym"
                imageSourceDesktop={image.src}
                imageSourceMobile={image.src}
            />
        </Layout>
    );
}
